import {
  ConfluenceSiteAriResourceOwner,
  ConfluenceSiteAriResourceType
} from "./chunk-PVOLGFB2.mjs";
import {
  RegisteredAri
} from "./chunk-YG2E6ZVD.mjs";
import {
  AriParser
} from "./chunk-Q7FABYST.mjs";

// src/confluence/site/manifest.ts
var confluenceSiteAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: ConfluenceSiteAriResourceOwner,
  resourceType: ConfluenceSiteAriResourceType,
  resourceIdSlug: "{siteId}",
  resourceIdSegmentFormats: {
    siteId: /[a-zA-Z0-9_\-.]{1,255}/
    // eslint-disable-line no-useless-escape
  }
};

// src/confluence/site/index.ts
var ConfluenceSiteAri = class _ConfluenceSiteAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.resourceIdSegmentValues.siteId;
  }
  get siteId() {
    return this._siteId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: confluenceSiteAriStaticOpts.qualifier,
      platformQualifier: confluenceSiteAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: confluenceSiteAriStaticOpts.resourceOwner,
      resourceType: confluenceSiteAriStaticOpts.resourceType,
      resourceId: `${opts.siteId}`,
      resourceIdSegmentValues: {
        siteId: opts.siteId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, confluenceSiteAriStaticOpts);
    return new _ConfluenceSiteAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, confluenceSiteAriStaticOpts);
    return new _ConfluenceSiteAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId
    };
  }
};

export {
  ConfluenceSiteAri
};
